import {Component, EventEmitter, Inject, Output} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-serial-code',
    templateUrl: 'dialog-show-detailed-message.html',
    styleUrls: ['dialog-show-detailed-message.scss']
})
export class DialogShowDetailedMessageComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: {message: string, title: string , needsCloseButton?: boolean},
                private dialogRef: MatDialogRef<DialogShowDetailedMessageComponent>) {}

    @Output() closeDialog: EventEmitter<void> = new EventEmitter<void>();

    onClose(): void {
        this.closeDialog.emit();
    }

}
